import request from 'graphql-request';
import { gameInsightQuery } from './Graphql/Queries/gameInsightsQuery';
import { getToken } from './helpers';
import logger from './logger';

export async function fetchGameInsightData(variables, url) {
  try {
    const token = await getToken();
    const data = await request(
      url,
      gameInsightQuery,
      variables,
      { authorization: token }
    );
    return data;
  } catch (error) {
    logger(`Error in fetching game insight data: ${error.message}`, 'error');
    return undefined;
  }
}